import { BodyBlockV2Item, getBaseBlockType } from 'constants/bodyBlocks';
import { StoreBodyBlock } from 'constants/enums';

const isSingleOnePlusManySlot = (blocks: StoreBodyBlock[]): boolean =>
  blocks.length === 1 && blocks[0] === StoreBodyBlock.onePlusMany;

const toBaseBlocks = (item: BodyBlockV2Item): StoreBodyBlock[] =>
  item.blocks.map(getBaseBlockType);

export const collapseOnePlusManyToSingleSlot = (
  items: BodyBlockV2Item[]
): BodyBlockV2Item[] => {
  const anyOnePlusManyVisible = items.some(
    (item) =>
      item.isVisible &&
      toBaseBlocks(item).includes(StoreBodyBlock.onePlusMany)
  );

  const firstSlotIndex = items.findIndex((item) =>
    isSingleOnePlusManySlot(toBaseBlocks(item))
  );

  return items
    .filter(
      (item, index) =>
        index === firstSlotIndex || !isSingleOnePlusManySlot(toBaseBlocks(item))
    )
    .map((item) => {
      const blocks = toBaseBlocks(item);
      if (!isSingleOnePlusManySlot(blocks)) return { ...item, blocks };
      return {
        ...item,
        blocks,
        isVisible: anyOnePlusManyVisible,
        isMergeable: false
      };
    });
};

export const revealBodyBlockInV2Order = (
  items: BodyBlockV2Item[],
  block: StoreBodyBlock
): { nextItems: BodyBlockV2Item[]; wasAlreadyVisible: boolean } => {
  const index = items.findIndex((it) => it.blocks.includes(block));
  if (index === -1) {
    return { nextItems: items, wasAlreadyVisible: true };
  }

  const item = items[index];
  if (item.isVisible) {
    return { nextItems: items, wasAlreadyVisible: true };
  }

  const updated: BodyBlockV2Item = { ...item, isVisible: true };
  const without = [...items.slice(0, index), ...items.slice(index + 1)];

  let insertAt = without.length;
  for (let i = without.length - 1; i >= 0; i--) {
    if (without[i].isVisible) {
      insertAt = i + 1;
      break;
    }
  }

  return {
    nextItems: [
      ...without.slice(0, insertAt),
      updated,
      ...without.slice(insertAt)
    ],
    wasAlreadyVisible: false
  };
};
